module.exports = __webpack_public_path__ + "img/dribble.e43bf9b1.svg";